import {
  putRequest,
} from './../../../servos/apiRequests'

const onSuccess = (data) => {
  return { response: data.data }
}

const onFailure = (error) => {
  return { error }
}

export const gobackLoanApplicationUser = (applicationId) => {
  let url = `/loan_applications/${applicationId}/loan_application_user/goback.json`
  let data = {}

  return putRequest({ url, data, onSuccess: onSuccess, onFailure: onFailure })
}

export const gotoLoanApplicationUser = (applicationId, flowState) => {
  let url = `/loan_applications/${applicationId}/loan_application_user/goto.json`
  let data = {
    loan_application_user: {
      flow_state: flowState
    }
  }
  return putRequest({ url, data, onSuccess: onSuccess, onFailure: onFailure })
}

export const putLoanApplicationUser = (applicationId, data) => {
  let url = `/loan_applications/${applicationId}/loan_application_user.json`
  return putRequest({ url, data, onSuccess: onSuccess, onFailure: onFailure })
}

export const putVerifyLoanApplicationUser = (applicationId, data) => {
  let url = `/loan_applications/${applicationId}/loan_application_user/verify.json`
  return putRequest({ url, data, onSuccess: onSuccess, onFailure: onFailure })
}
